import stye from "../CardsModal.module.css";
import {useTranslation} from "react-i18next";
import PresentToAllOutlinedIcon from '@mui/icons-material/PresentToAllOutlined';
import {OverlayTrigger, Tooltip} from "react-bootstrap";
import React from "react";
import useWebSocket from "react-use-websocket";
import {useParams, useSearchParams} from "react-router-dom";
import {wsBaseUrl} from "../../api/ApiUtils";

function SelectedCard(props) {
    const {t, i18n} = useTranslation('translation', {keyPrefix: 'selectedCard'});
    const params = useParams()
    const [queryParams] = useSearchParams()

    const {
        sendJsonMessage,
        lastJsonMessage,
        readyState
    } = useWebSocket(wsBaseUrl + `ws/game/${params.id}/stream`, {
        shouldReconnect: () => true,
        share: true
    });

    function shareMac() {
        console.log(props)
        sendJsonMessage(
            {
                message: {
                    name: "share_card",
                    shared_by: queryParams.get("player"),
                    card_link: props.selectedCardlink,
                    deck_id: props.selectedStackData.deck_id
                }
            }
        )
    }

    return (
        <div className={`${props.selectedCardClassName} ${stye.cardSelectedContainer}`}>
            <img src={props.selectedCardlink}
                 className={stye.cardSelected}
                 alt={"Not found"}
                 onContextMenu={(evt) => {
                     evt.preventDefault()
                 }}
                 onDragStart={(event) => {
                     event.preventDefault()
                     return false
                 }}
            />
            {props.allowShare && <OverlayTrigger overlay={<Tooltip id="button-tooltip">{t('shareMacCard')}</Tooltip>}>
                <PresentToAllOutlinedIcon
                    onClick={shareMac}
                    fontSize="large"
                    style={{
                        position: "absolute",
                        bottom: "20px",
                        right: "8px",
                        backgroundColor: "rgba(255,255,255,0.5)",
                        borderRadius: "3px",
                        cursor: "pointer",
                    }}/>
            </OverlayTrigger>
            }

            <span
                style={{
                    fontSize: "8px"
                }}
            >{t('author')}:
                <a href={props.selectedStackData.author_link}
                   target={"_blank"}>{i18n.language === "en" ? props.selectedStackData.author_name_en : props.selectedStackData.author_name_ua}</a>
            </span>
        </div>
    )
}

export default SelectedCard